<template>
    <div class="col-md-6 drop-lg">

        <div v-if="canUpdatePaymentOptions && ! creditDisabled">
            <div class="payment-group sau-bx-payment active d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400 cursor-default">
                <div>
                    <span class="mt-2"></span>
                    <img src="/img/account-credit.gif" alt="Account Credit" class="img-fluid pb-2">
                    <p class="sau-font sm">Account Balance: ${{ credit }}</p>
                </div>
                <div class="payment-method-options">
                    <div class="sau-menu">
                        <button class="dropbtn text-green">
                            Options
                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                        </button>
                        <div class="sau-menu-content dd py-3 px-4">
                            <a href="/account/prepayments" class="d-block btn">Add Account Credit</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- credit option -->
        <div v-if="! canUpdatePaymentOptions && credit > 0 && ! creditDisabled" @click.prevent="setPaymentMethod('credit')">
            <div class="payment-group sau-select lg center payment d-flex-column h-100 justify-content-center pb-12 border-grey-400 hover:border-grey-400" :class="{ selected: this.paymentMethodSelected === 'credit' }">
                <label for="credit">
                    <input id="credit" type="radio" name="payment-type" value="credit" v-model="this.paymentMethodSelected">
                    <span class="mt-2"></span>
                    <img src="/img/account-credit.gif">
                    <p class="sau-font sm">Account Balance: ${{ credit }}</p>
                </label>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        props: ['credit'],

        computed: {
            billingDetails() {
                return this.userDetails.billing;
            },
            creditDisabled() {
                return window.location.href.indexOf('order') > -1; // Don't render on order page
            },
            ...mapGetters(['canUpdatePaymentOptions']),
        },
    }

</script>
